//.....API ENDPOINT (LOCAL / PRODUCTION)
// const ApiUrl = process.env.NODE_ENV === 'development' ? 'http://10.238.103.143:3000' : 'https://api.proasysinc.com';
// const ApiUrl = process.env.NODE_ENV === 'development' ? 'http://192.168.1.102:3000' : 'http://api.proasysinc.com';
// const ApiUrl = process.env.NODE_ENV === 'development' ? 'http://10.238.103.143:5000' : 'https://api.proasysinc.com';
const ApiUrl = process.env.REACT_APP_API_URL;
// const ApiUrl = 'https://api.proasysinc.com';
//.....................................


export const fetchBegin = (message = 'Loading...') => ({
  type: 'FETCH_BEGIN',
  message: message  
})

export const fetchSuccess = (payload) => ({
  type: 'FETCH_SUCCESS',
  payload: payload
})

export const fetchSessionSuccess = (payload) => ({
  type: 'FETCH_SESSION_SUCCESS',
  payload: payload
})

export const fetchAccountsSuccess = (payload) => ({
  type: 'FETCH_ACCOUNTS_SUCCESS',
  payload: payload
})

export const fetchProductsSuccess = (payload) => ({
  type: 'FETCH_PRODUCTS_SUCCESS',
  payload: payload
})

export const fetchReportSuccess = (report) =>  ({
  type: 'FETCH_REPORT_SUCCESS',
  report: report
})

export const fetchReportDraftsSuccess = (drafts) => ({
  type: 'FETCH_REPORT_DRAFTS_SUCCESS',
  drafts: drafts
})

export const fetchInfoSuccess = (info) => ({
  type: 'FETCH_INFO_SUCCESS',
  info: info
})

export const fetchFailure = (error) => ({
  type: 'FETCH_FAILURE',
  payload: error
})

export const clearSession = (message) => ({
  type: 'CLEAR_SESSION',
  message: message
})

export const deleteReportSuccess = (payload) => ({
  type: 'DELETE_REPORT_SUCCESS',
  payload: payload
})

export const exitReport = () => ({
  type: 'EXIT_REPORT'
})

export const reportSubmitted = (payload) => ({
  type: 'REPORT_SUBMITTED',
  payload: payload
})

export const fetchCalendarSuccess = (payload) => ({
  type: 'FETCH_CALENDAR_SUCCESS',
  payload: payload
})

export const createEvent = (eventData) => ({
  type: 'NEW_EVENT',
  payload: eventData
})

export const destroyEventSuccess = (eventId) => ({
  type: 'DESTROY_EVENT',
  eventId: eventId
})

export const fetchTestHistorySuccess = (component, test, history) => ({
  type: 'LOAD_TEST_HISTORY',
  component: component,
  test: test,
  history: history
})

export const clearError = () => ({
  type: 'CLEAR_ERROR'
})

export const testError = () => ({
  type: 'TEST_ERROR'
})

export const fetchReportHistorySuccess = (reports, options = {}) => ({
  type: 'REPORT_HISTORY',
  reports,
  append: !!options.append,
  total_count: options.total_count,
  has_more: options.has_more,
})

export const fetchOrderHistorySuccess = (orders, append) => ({
  type: 'ORDER_HISTORY',
  append: append || null,
  orders: orders
})

export const fetchOrderProductsSuccess = (products) => ({
  type: 'FETCH_ORDER_PRODUCTS_SUCCESS',
  products
})

export const saveOrderSuccess = (order, options = {}) => ({
  type: 'SAVE_ORDER_SUCCESS',
  order,
  silent: !!options.silent,
})

export const fetchOrderDraftsSuccess = (orders) => ({
  type: 'ORDER_DRAFTS',
  orders
})

export const loadOrderDraftSuccess = (order) => ({
  type: 'LOAD_ORDER_DRAFT_SUCCESS',
  order
})

export const deleteOrderDraftSuccess = (id) => ({
  type: 'DELETE_ORDER_DRAFT_SUCCESS',
  id
})

export const clearActiveOrderDraft = () => ({
  type: 'CLEAR_ACTIVE_ORDER_DRAFT'
})

export const initialDataLoaded = (state) => ({
  type: 'INITIAL_LOAD',
  state: state
})

export const fetchTestFieldsSuccess = (tests) => ({
  type: 'TEST_FIELDS',
  payload: tests
})

function validateResponseStatus(response) {
  console.log('validating response', response);
  try {
    if (response.status === 200) { // response okay
      return response.json().then(json => {
        if (json.success === false) { // response is okay but server threw an error
          throw new Error(json.error);
        }
        return json; // json okay
      });
    }
    
    if (response.status === 401) {
      // Throw specific error type for 401
      throw new Error("SESSION_EXPIRED");
    }
    
    const fallback = `Request failed with status ${response.status}`;
    return response.json()
      .catch(() => ({}))
      .then(json => {
        throw new Error(typeof json?.error === 'string' ? json.error : fallback);
      });
  } catch (error) {
    throw error;
  }
}

function handleApiError(dispatch, error) {
  dispatch(fetchFailure(error));

  if (error.message === "SESSION_EXPIRED") {
    dispatch(clearSession('Your session has expired. Please log in again.'));
  }  
  throw error;
}

export function fetchMSSession(token, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Fetching session token...'));
    console.log('got MS token', token)

    return fetch(`${ApiUrl}/newsesh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: token
      })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch(fetchSessionSuccess(json))
      return json
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchSession(username, password, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Fetching session token...'));

    return fetch(`${ApiUrl}/newsesh`, { // call to api
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: username,
        password: password
      })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      json.user.username = json.user.username || username
      dispatch(fetchSessionSuccess(json))
      return json
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function refreshSession(token, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Refreshing session token...'));

    return fetch(`${ApiUrl}/auth/refresh`, {
      method: 'POST',
      headers: {
        'Authorization': token
      }
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch(fetchSessionSuccess({
        ...json,
        auth_token: token
      }))
      return json
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function changePassword(password, passwordConfirmation) {
  return (dispatch, getState) => {
    dispatch(fetchBegin('Updating password...'));
    const token = getState().authToken;

    return fetch(`${ApiUrl}/auth/change_password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
      body: JSON.stringify({
        password,
        password_confirmation: passwordConfirmation,
      }),
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch(fetchSessionSuccess(json));
      return json;
    })
    .catch((error) => handleApiError(dispatch, error));
  };
}

export function debugSession(newToken) {
  console.log('running debugsession action');
  if (process.env.NODE_ENV === 'development') {
    return dispatch => {
      dispatch({
        type: 'DEBUG_SESSION',
        newToken: newToken
      })
    }  
  }
}

export function updateColorScheme(colorScheme, token) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_COLOR_SCHEME',
      payload: colorScheme
    });

    return fetch(`${ApiUrl}/update_color_scheme`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(colorScheme)
    })
  }
}

export function fetchReportsList(token, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Fetching reports list...'));
    return fetch(`${ApiUrl}/reports_list`, {
      method: 'POST',
      headers: {
        'Authorization': token
      }
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'FETCH_REPORTS_LIST_SUCCESS',
        payload: json
      });
      if (onSuccess) {onSuccess()};
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchScheduledServiceList(token, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Fetching scheduled service list...'));

    return fetch(`${ApiUrl}/scheduled_service_list`, {
      method: 'POST',
      headers: {
        'Authorization': token
      }
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'FETCH_SCHEDULED_SERVICE_LIST_SUCCESS',
        payload: json
      });
      if (onSuccess) {onSuccess()};
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchReport(token, id, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Fetching report...'));
    console.log('gimme report', id);

    return fetch(`${ApiUrl}/reports/edit?id=${id}`, {
      method: 'POST',
      headers: {
        'Authorization': token
      }
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch(fetchReportSuccess(json));
      if (onSuccess) {onSuccess()};
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchAccounts(token, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Fetching accounts list...'));

    return fetch(`${ApiUrl}/customers`, {
      method: 'POST',
      headers: {
        'Authorization': token
      }
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch(fetchAccountsSuccess(json));
      if (onSuccess) {onSuccess()};
      return json;
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchProducts(token, onSuccess) {
  console.log('auth_token: ', token);
  return dispatch => {
    dispatch(fetchBegin('Fetching products list...'));

    return fetch(`${ApiUrl}/products`, {
      method: 'POST',
      headers: {
        'Authorization': token
      }
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch(fetchProductsSuccess(json));
      if (onSuccess) {onSuccess()};
      return json;
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

// scope: 'all' returns every employee's drafts (admins only); otherwise your own.
export function fetchReportDrafts(customer, token, onSuccess, { replaceGlobal = true, scope } = {}) {
  return dispatch => {
    if (replaceGlobal) {
      dispatch(fetchBegin('Fetching report drafts...'));
    }

    return fetch(`${ApiUrl}/reports/drafts`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({customer_id: `${customer}`, scope})
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      if (replaceGlobal) {
        dispatch(fetchReportDraftsSuccess(json));
      }
      return json;
    })
    .then((drafts) => {
      if (onSuccess) {onSuccess(drafts)};
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function logOut() {
  return dispatch => {
    dispatch(clearSession());
  }
}

// templateId: start a service report from one of the account's report
// templates instead of the last report's layout.
export function createReport(customer, reportType, eventId, token, onSuccess, templateId) {
  return dispatch => {
    dispatch(fetchBegin('Creating new report...'));

    return fetch(`${ApiUrl}/reports/new?customer=${customer}&type=${reportType}${eventId ? '&event='+eventId : ''}${templateId ? '&template='+templateId : ''}`, {
      method: 'POST',
      headers: {
        'Authorization': token
      }
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch(fetchSuccess(json));
      if (onSuccess) {onSuccess(json.hash_id)};
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function updateReport(update, storage, onComplete) {
  update.last_edit = Math.floor(Date.now() / 1000) // convert to seconds for mysql

  return dispatch => {
    dispatch({
      type: 'UPDATE_REPORT',
      payload: update,
      local: storage?.fridge,
      freeze: storage?.freezer
    });

    if (storage?.freezer) {
      // beam it up to api

      return fetch(`${ApiUrl}/reports/update`, {
        method: 'POST',
        headers: {
          'Authorization': storage.freezer,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          update: update
        })
      })
      .then((response) => validateResponseStatus(response))
      .then((json) => {
        if (json['status'] === 'updated') {
          console.log('updated report', json.breadcrumbs);
          dispatch({
            type: 'CONFIRM_REPORT_UPDATE',
            payload: {
              breadcrumbs: json.breadcrumbs,
              id_remap: json.id_remap || {}, // {tempId: realId} for components created on this round-trip
              positions: json.positions || {}, // {componentId: {tests: {id: position}, notes: {id: position}}} assigned by the server
              calculated: json.calculated || {}, // {resultId: {component_id, result, calc}} for calculated tests, as the server worked them out
            }
          });
          if (onComplete) {onComplete(json.breadcrumbs)};
        }
      })
      .catch((error) => handleApiError(dispatch, error))
    } else {
      if (onComplete) {onComplete()}
    }
  }
}

export function submitReport(report, token, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Submitting report...'));

    return fetch(`${ApiUrl}/reports/submit`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        report: report
      })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch(reportSubmitted(json));
      // console.log('report save response:', response.json());
      if (json['status'] === 'saved') {
        onSuccess();
      }
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchTestHistory(componentId, testId, token) {
  return dispatch => {
    dispatch(fetchBegin('Fetching test history...'));

    return fetch(`${ApiUrl}/reports/history`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        component: componentId,
        test: testId
      })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch(fetchTestHistorySuccess(componentId, testId, json));
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function quitReport() {
  console.log('closing report');
  return dispatch => {
    dispatch(exitReport())
  }
}

export function destroyReport(id, token, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Deleting report...'));

    return fetch(`${ApiUrl}/reports/destroy`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        report: id
      })
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      if (json.status === 'deleted') {
        dispatch(deleteReportSuccess(id))
        if (onSuccess) {onSuccess()}
      }
    })
    .then(() => {
      // change associated event in local state
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function resendReport(id, token, recipients, onSuccess, onError) {
  return dispatch => {
    dispatch(fetchBegin('Resending report...'));

    return fetch(`${ApiUrl}/reports/resend`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: id,
        recipients: recipients
      })
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      dispatch(fetchSuccess(json));
      if (json.status === 'resent') {
        if (onSuccess) {onSuccess()}
      } else if (onError) {
        onError(json);
      }
    })
    .catch((error) => {
      handleApiError(dispatch, error);
      if (onError) {onError(error)}
    })
  }
}

export function fetchCalendar(token, month, employeeID, onSuccess) {
  // month should be supplied as string 'YYYY-MM'
  return dispatch => {
    dispatch(fetchBegin('Fetching calendar data...'));

    return fetch(`${ApiUrl}/schedule/load`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        month: month,
        employee: employeeID
      })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch(fetchCalendarSuccess(json));
      if (onSuccess) {onSuccess()};
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function newEvent(token, eventData, onSuccess) {
  console.log('firing here with', eventData);
  return dispatch => {
    dispatch(fetchBegin('Creating new event...'));

    return fetch(`${ApiUrl}/schedule/new`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        customer: eventData.customer,
        date: eventData.date,
        time_in: eventData.time_in,
        time_out: eventData.time_out,
        note: eventData.note
      })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      if (json.status === "saved") {
        dispatch(createEvent(json.event))
      }
    })
    .then(() => {
      if (onSuccess) {onSuccess()}
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function updateEvent(token, eventData, onSuccess) { // needs work
  console.log('sending event update', eventData);
  return dispatch => {
    if (token) {
      dispatch(fetchBegin('Updating event...'));

      return fetch(`${ApiUrl}/schedule/update`, {
        method: 'POST',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(eventData)
      })
      .then((response) => validateResponseStatus(response))
      .catch((error) => handleApiError(dispatch, error))
    } else {
      dispatch({
        type: 'UPDATE_EVENT',
        payload: eventData
      });
    }
    if (onSuccess) {
      onSuccess();
    }
  }
}

export function destroyEvent(token, eventData) {
  return dispatch => {
    dispatch(fetchBegin('Deleting event...'));

    return fetch(`${ApiUrl}/schedule/delete`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(eventData)
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      if (json.status === 'deleted') {
        dispatch(destroyEventSuccess(eventData.id))
      }
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function repeatEvent(token, eventRepeat) {
  
}

export function fetchReportHistory(token, onSuccess, options = {}) {
  const { offset = 0, limit = 20, append = false, q = '' } = options;

  return dispatch => {
    if (!append) {
      dispatch(fetchBegin('Fetching report history...'));
    }

    return fetch(`${ApiUrl}/reports/history`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        offset,
        limit,
        length: limit,
        q: q || undefined,
      })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      const reports = Array.isArray(json) ? json : (json.reports || []);
      const total_count = Array.isArray(json) ? reports.length : json.total_count;
      const has_more = Array.isArray(json) ? false : !!json.has_more;
      const payload = { reports, total_count, has_more, offset, limit, q, append };

      // Caller can return false to ignore a stale response (e.g. superseded search).
      if (onSuccess && onSuccess(payload) === false) {
        if (!append) {
          dispatch({ type: 'FETCH_SUCCESS', response: null });
        }
        return payload;
      }

      dispatch(fetchReportHistorySuccess(reports, {
        append,
        total_count,
        has_more,
      }));

      return payload;
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchOrderHistory(token, onSuccess, options = {}) {
  const { length = 20, append = false } = options;
  return dispatch => {
    dispatch(fetchBegin('Fetching order history...'));
    return fetch(`${ApiUrl}/orders/history`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ length })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      let orders = json;
      if (typeof orders === 'string') {
        try { orders = JSON.parse(orders); } catch { orders = []; }
      }
      if (!Array.isArray(orders)) orders = [];
      dispatch(fetchOrderHistorySuccess(orders, append));
      if (onSuccess) { onSuccess(orders); }
      return orders;
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export const fetchOrderDeliveryOptionsSuccess = (options) => ({
  type: 'FETCH_ORDER_DELIVERY_OPTIONS_SUCCESS',
  options
});

export function fetchOrderDeliveryOptions(token, customerId, onSuccess) {
  return dispatch => {
    return fetch(`${ApiUrl}/orders/delivery_options`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ customer_id: customerId || null })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      const options = Array.isArray(json) ? json : [];
      dispatch(fetchOrderDeliveryOptionsSuccess(options));
      if (onSuccess) { onSuccess(options); }
      return options;
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchOrderProducts(token, category, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Loading products...'));
    return fetch(`${ApiUrl}/orders/products`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ type: category })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      const products = Array.isArray(json) ? json : [];
      dispatch(fetchOrderProductsSuccess(products));
      if (onSuccess) { onSuccess(products); }
      return products;
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function saveOrder(token, orderPayload, onSuccess, options = {}) {
  const asDraft = !!orderPayload?.draft;
  const silent = !!options.silent;
  return dispatch => {
    if (!silent) {
      dispatch(fetchBegin(asDraft ? 'Saving draft...' : 'Submitting order...'));
    }
    return fetch(`${ApiUrl}/orders/save`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ order: orderPayload })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      let order = json;
      if (typeof order === 'string') {
        try { order = JSON.parse(order); } catch { /* keep string */ }
      }
      dispatch(saveOrderSuccess(order, { silent }));
      if (onSuccess) { onSuccess(order); }
      return order;
    })
    .catch((error) => handleApiError(dispatch, error))
    .finally(() => {
      if (options.onSettled) options.onSettled();
    })
  }
}

export function fetchOrderDrafts(token, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Fetching order drafts...'));
    return fetch(`${ApiUrl}/orders/drafts`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({})
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      let orders = json;
      if (typeof orders === 'string') {
        try { orders = JSON.parse(orders); } catch { orders = []; }
      }
      if (!Array.isArray(orders)) orders = [];
      dispatch(fetchOrderDraftsSuccess(orders));
      if (onSuccess) { onSuccess(orders); }
      return orders;
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function loadOrderDraft(token, orderId, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Loading order...'));
    return fetch(`${ApiUrl}/orders/load`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: orderId })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      let order = json;
      if (typeof order === 'string') {
        try { order = JSON.parse(order); } catch { order = null; }
      }
      dispatch(loadOrderDraftSuccess(order));
      if (onSuccess) { onSuccess(order); }
      return order;
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function deleteOrderDraft(token, orderId, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Deleting draft...'));
    return fetch(`${ApiUrl}/orders/destroy`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: orderId })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch(deleteOrderDraftSuccess(orderId));
      if (onSuccess) { onSuccess(json); }
      return json;
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function initializeOrders(token, options = {}) {
  let onSuccess;
  if (typeof options === 'function') {
    onSuccess = options;
  } else {
    onSuccess = options.onSuccess;
  }
  return dispatch => {
    return Promise.all([
      dispatch(fetchOrderHistory(token, null, { length: options.historyLength || 20 })),
      dispatch(fetchOrderDrafts(token)),
      dispatch(fetchAccounts(token))
    ]).then(() => {
      if (onSuccess) onSuccess();
    });
  }
}

export function fetchInfo(token, id, type, onSuccess, options = {}) {
  const { updateHistory = true } = options;

  return dispatch => {
    dispatch(fetchBegin('Fetching Lookup info...'));
    console.log('sending info request with params', type, id);
    return fetch(`${ApiUrl}/info`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        type: type,
        id: id
      })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch(fetchInfoSuccess(json))
      if (updateHistory) {
        window.history.pushState(null, '', `/lookup?type=${type}&id=${id}`);
      }
      if (onSuccess) {onSuccess()}
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchMoreReports(token, customerId, offset, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Loading more reports...'));
    return fetch(`${ApiUrl}/more_reports`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        customer_id: customerId,
        offset: offset,
        limit: 10
      })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'FETCH_MORE_REPORTS_SUCCESS',
        payload: json
      });
      if (onSuccess) {onSuccess(json)}
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function initializeQuotes(token, options = {}) {
  let onSuccess;
  let draftsPage = 1;
  let draftsPerPage = 10;
  let draftsList = 'drafts';
  if (typeof options === 'function') {
    onSuccess = options;
  } else {
    onSuccess = options.onSuccess;
    if (options.draftsPage != null) draftsPage = Number(options.draftsPage);
    if (options.draftsPerPage != null) draftsPerPage = Number(options.draftsPerPage);
    if (options.draftsList != null) draftsList = options.draftsList;
  }

  return dispatch => {
    dispatch(fetchBegin('Fetching quotes...'));
    return fetch(`${ApiUrl}/quotes/initialize`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        drafts_page: draftsPage,
        drafts_per_page: draftsPerPage,
        drafts_list: draftsList,
      })
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'INITIALIZE_QUOTES_SUCCESS',
        payload: json
      })
      if (onSuccess) {onSuccess()}
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchQuoteDraftsPage(token, page, perPage = 10, draftsList = 'drafts') {
  return dispatch => {
    return fetch(`${ApiUrl}/quotes/drafts`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        drafts_page: page,
        drafts_per_page: perPage,
        drafts_list: draftsList,
      })
    })
      .then((response) => validateResponseStatus(response))
      .then((json) => {
        dispatch({
          type: 'QUOTE_DRAFTS_PAGE_SUCCESS',
          payload: { ...json, drafts_list: draftsList },
        });
      })
      .catch((error) => handleApiError(dispatch, error));
  };
}

export function newQuote(token, quoteData, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Creating new quote...'));

    return fetch(`${ApiUrl}/quotes/new`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(quoteData)
    })
    .then((response) => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'NEW_QUOTE_SUCCESS',
        payload: json
      })
      if (onSuccess) {onSuccess()}
    })
    .catch((error) => handleApiError(dispatch, error))
  } 
}

export function updateQuote(quoteData, token, onSuccess, onError) {
  if (!quoteData) {return false};
  console.log('updating quote...', quoteData);
  return dispatch => {
    if (token) {
      dispatch(fetchBegin('Updating quote...'));

      return fetch(`${ApiUrl}/quotes/update`, {
        method: 'POST',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({quote: quoteData})
      })
      .then(response => validateResponseStatus(response))
      .then((json) => {
        dispatch({
          type: 'UPDATE_QUOTE',
          payload: json.quote,
          idRemap: json.id_remap || {},
        })
        if (onSuccess) {onSuccess(json.quote, json.id_remap || {})}
      })
      .catch((error) => {
        handleApiError(dispatch, error);
        if (onError) {onError()}
      })
    } else {
      dispatch({
        type: 'UPDATE_QUOTE',
        payload: quoteData
      })
      if (onSuccess) {onSuccess()}
    }
  } 
}

export function loadQuoteDraft(token, quoteId, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Loading quote...'));
    return fetch(`${ApiUrl}/quotes/load_draft`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ quote_id: quoteId })
    })
      .then(response => validateResponseStatus(response))
      .then((json) => {
        dispatch({
          type: 'LOAD_QUOTE_SUCCESS',
          payload: { quote: json.quote }
        });
        if (onSuccess) onSuccess(json.quote);
      })
      .catch((error) => handleApiError(dispatch, error));
  };
}

export function loadQuote(token, quoteId, loadQuotableProducts = false, onSuccess) {
  if (!quoteId) { // if no quote id, clear the active quote
    return dispatch => {
      dispatch({
        type: 'LOAD_QUOTE_SUCCESS',
        payload: {
          quote: null
        }
      })
    }
  } else {
    return dispatch => {
      dispatch(fetchBegin('Loading quote...'));

      return fetch(`${ApiUrl}/load_quote`, {
        method: 'POST',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          quote: quoteId,
          loadQuotableProducts: loadQuotableProducts
        })
      })
      .then(response => validateResponseStatus(response))
      .then((json) => {
        dispatch({
          type: 'LOAD_QUOTE_SUCCESS',
          payload: json
        })
      })
      .catch((error) => handleApiError(dispatch, error))
    }
  }
}

export function deleteQuote(token, quoteId, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Deleting quote...'));
    return fetch(`${ApiUrl}/delete_quote`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({quote: quoteId})
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'DELETE_QUOTE_SUCCESS',
        payload: json.quote
      });
      if (onSuccess) onSuccess();
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function submitQuote(token, quoteId, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Submitting quote...'));
    return fetch(`${ApiUrl}/submit_quote`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({quote: quoteId})
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'SUBMIT_QUOTE_SUCCESS',
        payload: json.quote
      })
      if (onSuccess) {onSuccess()}
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fileUpload(token, formData, onSuccess) {
  console.log('uploading file', formData);  
  return async dispatch => {
    dispatch(fetchBegin('Uploading file...'));

    return fetch(`${ApiUrl}/fileman/upload`, {
      method: 'POST',
      headers: {
        'Authorization': token,
      },
      body: formData
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      console.log('file upload response', json);
      dispatch({
        type: 'FILE_UPLOAD_SUCCESS',
        payload: json.file
      })
      if (onSuccess) {onSuccess()}
    })
    .catch((error) => handleApiError(dispatch, error));
  }
}

export function renameFile(token, customerId, fileId, newName, onSuccess) {
  return dispatch => {
    // dispatch(fetchBegin('Renaming file...'));
    return fetch(`${ApiUrl}/rename_file`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        customer_id: customerId,
        file_id: fileId,
        name: newName
      })
    })  
    .then(response => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'RENAME_FILE_SUCCESS',
        payload: json.file
      })  
      if (onSuccess) {onSuccess()}
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

// export function mailFile(token, customerId, fileId, recipients, note, onSuccess) {


export function deleteFile(token, fileId) {
  return dispatch => {
    dispatch(fetchBegin('Deleting file...'));
    return fetch(`${ApiUrl}/fileman/delete`, {
      method: 'POST',
      headers: {
        'Authorization': token, 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: fileId
      })
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      console.log('file delete response', json);
      dispatch({
        type: 'DELETE_FILE_SUCCESS',
        payload: fileId
      })
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function clearInfo() {
  return dispatch => {
    dispatch(({
      type: 'CLEAR_INFO'
    }))
  }
}

export function fetchTestFields(token, { silent } = {}) {
  return dispatch => {
    if (!silent) {
      dispatch(fetchBegin('Fetching report tests...'));
    }
    console.log('fetching report tests');
    return fetch(`${ApiUrl}/reports/tests`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      dispatch(fetchTestFieldsSuccess(json))
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function editCompTest(token, test, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Editing test...'));

    return fetch(`${ApiUrl}/reports/edit_test`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(test)
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      // server should have returned new template, put it in the fridge
      dispatch({
        type: 'UPDATE_REPORT_TEMPLATE',
        payload: json
      });

      if (onSuccess) {onSuccess()}
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function setNavHeader(headerText) {
  return dispatch => {
    dispatch({
      type: 'NAV_HEADER',
      payload: headerText
    });
  }
}

export function showNav(bool) {
  return dispatch => {
    dispatch({
      type: 'SHOW_NAV',
      payload: bool
    });
  }
}

// Admin only: { id, description, serviced_by } renames a system and reassigns
// its technician. Resolves with { equipment, technicians }; rejects with the
// server's message.
export function updateEquipment(equipment, authToken) {
  return apiPost('update_equipment', equipment, authToken);
}

export function updateLookupInfo(info) {
  return dispatch => {
    return new Promise((resolve) => {
      dispatch({
        type: 'UPDATE_LOOKUP_INFO',
        payload: info
      });
      resolve();
    });
  }
}

export function updateContact(update, authToken, onSuccess) {
  return dispatch => {
    // dispatch(fetchBegin('Saving contact info...'));
    return fetch(`${ApiUrl}/update_contact`, {
      method: 'POST',
      headers: {
        'Authorization': authToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({contact: update})
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      console.log('received update info response', json);
      dispatch({
        type: 'UPDATE_CONTACT_SUCCESS',
        payload: json
      })
      if (onSuccess) { onSuccess(json) }
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export const updateServiceLogLocal = (node) => ({
  type: 'UPDATE_SERVICE_LOG_LOCAL',
  payload: node
});

export function updateServiceLog(node, customerId, authToken, onSuccess) {
  return dispatch => {
    return fetch(`${ApiUrl}/update_service_log`, {
      method: 'POST',
      headers: {
        'Authorization': authToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        customer_id: customerId,
        node: node
      })
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'UPDATE_SERVICE_LOG_SUCCESS',
        payload: json
      })
      if (onSuccess) { onSuccess(json) }
      return json;
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchReportChanges(reportId, authToken) {
  return apiPost('reports/changes', { id: reportId }, authToken);
}

// Users and report templates live in the store (state.users, state.employees,
// state.reportTemplates, state.templateCatalogs) so the Admin dashboard and the
// account page cards share them. These actions also return the request's
// promise, which rejects with the server's message for inline form errors.

// type: all | staff | operators. Admins can list any type; account managers
// can only list operators, and must pass { customer_id }. The results replace
// the store's users in that scope.
export function fetchUsers(authToken, type = 'all', params = {}) {
  return apiPost(`users/list/${type}`, params, authToken, (json, dispatch) => dispatch({
    type: 'USERS_LOADED',
    payload: { users: json.users, employees: json.employees, positions: json.positions, scope: { type, customerId: params.customer_id } }
  }));
}

const userSaved = (json, dispatch) => dispatch({ type: 'USER_SAVED', payload: json.user });

// Staff: { type: 'staff', username, email, employee_id }, or new_employee:
// { first_name, last_name, position_id, managed_by, address: { street, city,
// state, zip, phone, description } } in place of employee_id to create the
// employee too. Operators:
// { type: 'operator', customer_id, first_name, last_name, username, email }.
// Password options: password | generate_password, temppass, send_invite.
export function createUser(user, authToken) {
  return apiPost('users/create', user, authToken, userSaved);
}

// Takes createUser's profile fields; staff can also send employee_address:
// { street, city, state, zip, phone, description } (all blank removes it).
export function updateUser(user, authToken) {
  return apiPost('users/update', user, authToken, userSaved);
}

// { id, password | generate_password, temppass, send_email }. For account
// managers the server always generates and emails a temporary password.
export function setUserPassword(body, authToken) {
  return apiPost('users/set_password', body, authToken, userSaved);
}

export function deactivateUser(id, authToken) {
  return apiPost('users/deactivate', { id }, authToken, userSaved);
}

export function reactivateUser(id, authToken) {
  return apiPost('users/reactivate', { id }, authToken, userSaved);
}

// Every templates response carries the account's full template list (and the
// catalog, except on delete), which replaces that account's templates.
const templatesLoaded = (json, dispatch) => dispatch({
  type: 'REPORT_TEMPLATES_LOADED',
  payload: { customerId: json.customer_id, templates: json.templates, catalog: json.catalog }
});

export function fetchReportTemplates(customerId, authToken) {
  return apiPost('report_templates/list', { customer_id: customerId }, authToken, templatesLoaded);
}

// { customer_id, name, components } or { customer_id, name, source_id } to duplicate.
export function createReportTemplate(template, authToken) {
  return apiPost('report_templates/create', template, authToken, templatesLoaded);
}

export function updateReportTemplate(template, authToken) {
  return apiPost('report_templates/update', template, authToken, templatesLoaded);
}

export function deleteReportTemplate(id, authToken) {
  return apiPost('report_templates/destroy', { id }, authToken, templatesLoaded);
}

// Templates any staff member can start a report from: [{ id, name, systems, tests }].
// Not kept in the store; the full templates above are for account managers.
export function fetchReportTemplateOptions(customerId, authToken) {
  return apiPost('reports/templates', { customer_id: customerId }, authToken);
}

// Sets where a calculated test's inputs come from on its system, for every
// report on the account: sources = { inputKey: { source, component_id,
// test_field_id } }. The report's calculated tests come back recalculated.
export function saveCalcSources(reportId, resultId, sources, authToken) {
  return apiPost('reports/calc_sources', { report_id: reportId, result_id: resultId, sources }, authToken, (json, dispatch) => dispatch({
    type: 'CALCULATED_RESULTS',
    payload: json.calculated || {}
  }));
}

// Formulas for calculated tests (Admin dashboard). Each resolves with
// { formulas, test_fields } and rejects with the server's message.
export function fetchCalculatedTests(authToken) {
  return apiPost('calculated_tests/list', {}, authToken);
}

// { id?, test_field_id? | test_name, unit?, formula, description, decimals, inputs: [{ key, label, test_field_id? }] }
export function saveCalculatedTest(formula, authToken) {
  return apiPost('calculated_tests/save', formula, authToken);
}

export function deleteCalculatedTest(id, authToken) {
  return apiPost('calculated_tests/destroy', { id }, authToken);
}

// POSTs JSON to the API and hands the response to onSuccess(json, dispatch).
// Rejects with the server's message so forms can show validation errors
// inline, instead of opening the global error modal.
function apiPost(path, body, authToken, onSuccess) {
  return dispatch => {
    return fetch(`${ApiUrl}/${path}`, {
      method: 'POST',
      headers: {
        'Authorization': authToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      if (onSuccess) onSuccess(json, dispatch);
      return json;
    })
    .catch((error) => {
      if (error.message === 'SESSION_EXPIRED') handleApiError(dispatch, error);
      throw error;
    })
  }
}

export function updateWastewaterPrice(update, authToken, onSuccess) {
  return dispatch => {
    return fetch(`${ApiUrl}/update_wastewater_price`, {
      method: 'POST',
      headers: {
        'Authorization': authToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ wastewater_price: update })
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'UPDATE_WASTEWATER_PRICE_SUCCESS',
        payload: json
      })
      if (onSuccess) { onSuccess(json) }
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function updateProductSds(authToken, { productId, file, sdsUrl }, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Saving SDS...'));

    const formData = new FormData();
    formData.append('product_id', productId);
    if (file) {
      formData.append('file', file);
    }
    if (sdsUrl) {
      formData.append('sds_url', sdsUrl);
    }

    return fetch(`${ApiUrl}/update_product_sds`, {
      method: 'POST',
      headers: {
        'Authorization': authToken,
      },
      body: formData
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      if (!json.success) {
        throw new Error(json.error || 'Failed to update SDS');
      }
      dispatch({
        type: 'UPDATE_PRODUCT_SDS_SUCCESS',
        payload: json
      })
      if (onSuccess) { onSuccess(json) }
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchRecentlySearched(token) {
  return dispatch => {
    dispatch(fetchBegin('Fetching recently searched...'));
    return fetch(`${ApiUrl}/recently_searched`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'FETCH_RECENTLY_SEARCHED_SUCCESS',
        payload: json
      })
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function fetchSystemReview(token, systemId, startDate, endDate, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Fetching system review...'));
    return fetch(`${ApiUrl}/system_review`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        system_id: systemId,
        start_date: startDate,
        end_date: endDate
      })
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'FETCH_SYSTEM_REVIEW_SUCCESS',
        payload: json.review
      })
      if (onSuccess) {onSuccess(json)}
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}   
export function fetchMapMarkers(token, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Fetching map markers...'));
    return fetch(`${ApiUrl}/map/markers`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      dispatch({
        type: 'FETCH_MAP_MARKERS_SUCCESS',
        payload: json
      })
      return json.employees
    }).then((employees) => {
      if (onSuccess) {onSuccess(employees)}
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function reassignAccountManager(token, accounts, employeeId, onSuccess) {
  return dispatch => {
    dispatch(fetchBegin('Reassigning account manager...'));
    return fetch(`${ApiUrl}/map/reassign_account_manager`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        accounts: accounts,
        employee_id: employeeId
      })
    })
    .then(response => validateResponseStatus(response))
    .then((json) => {
      if (onSuccess) {onSuccess()}
    })
    .catch((error) => handleApiError(dispatch, error))
  }
}

export function downloadEmployeesVcf(token, onSuccess, onError) {
  return dispatch => {
    dispatch(fetchBegin('Downloading employee contacts...'));

    return fetch(`${ApiUrl}/employees_vcf`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Accept': 'text/vcard',
      },
    })
    .then((response) => {
      if (response.status === 401) {
        throw new Error('SESSION_EXPIRED');
      }
      if (!response.ok) {
        return response.json()
          .then((json) => { throw new Error(json.error || 'Download failed'); })
          .catch((error) => {
            if (error.message && error.message !== 'Download failed') {
              throw error;
            }
            throw new Error('Download failed');
          });
      }

      const disposition = response.headers.get('Content-Disposition');
      let filename = 'proasys-employees.vcf';
      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match) filename = match[1];
      }

      return response.blob().then((blob) => ({ blob, filename }));
    })
    .then(({ blob, filename }) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      dispatch(fetchSuccess({}));
      if (onSuccess) onSuccess();
    })
    .catch((error) => {
      handleApiError(dispatch, error);
      if (onError) onError(error);
    });
  };
}